import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";
import {
    AcptCategoriesList,
    AcptFormType,
    AcptListResponse,
} from "@callveriq/type/Acpt";

export const acptApiSlice = createApi({
    reducerPath: "acptApiSlice",
    baseQuery: axiosBaseQuery({
        transformResponse: (response) => response,
    }),
    tagTypes: ["acpt"],
    endpoints: (builder) => ({
        getAcpt: builder.query<AcptListResponse[], void>({
            query: () => "/gpt/acpt/templates",
            providesTags: ["acpt"],
        }),
        updateAcpt: builder.mutation<
            AcptListResponse,
            { id: number } & (AcptFormType | { is_enabled: boolean })
        >({
            query: ({ id, ...data }) => ({
                url: `/gpt/acpt/templates/${id}/`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: ["acpt"],
        }),
        getAcptCategories: builder.query<AcptCategoriesList[], void>({
            query: () => "/gpt/acpt/categories",
            transformResponse: (response: { id: number; name: string }[]) =>
                response.map((e) => ({
                    id: e.id,
                    label: e.name,
                })),
        }),
    }),
});

export const {
    useGetAcptQuery,
    useUpdateAcptMutation,
    useGetAcptCategoriesQuery,
} = acptApiSlice;
